export const HasDiscordPermission = (permissions: string | number | bigint | null | undefined, permissionBit: string | number | bigint): boolean => {
    try {
        if (permissions === null || permissions === undefined) return false;
        return (BigInt(permissions) & BigInt(permissionBit)) === BigInt(permissionBit);
    } catch {
        return false;
    }
};
